import * as React from 'react';
import { CdnIcon } from '@shared/ui';
import UpgradeFlightClassCheckout from '../../../../../../CheckoutAdditionalService/components/UpgradeFlightClass/components/UpgradeFlightClass/UpgradeFlightClass';

const icons = [
	<CdnIcon key="Arrow/Upward" icon="Arrow/Upward" />,
	<CdnIcon key="Flight/Direction" icon="Flight/Direction" />
];

interface Props {
	segmentId: string;
}

const Upgrade: React.FC<Props> = ({ segmentId }) => {
	return <UpgradeFlightClassCheckout aggregationIcons={icons} mode="aggregator" segmentId={segmentId} />;
};

export default Upgrade;
